export const JsonData = {
  content_zh: {
    level1: [
      {
        title: '听',
        intro:
          '能简单理解与日常生活、数字等相关的关键词语。能听懂问候与招呼，明白基本的指示话语或要求。',
      },
      {
        title: '说',
        intro:
          '具备初步的口头表达能力，能够回应他人问候，问答基本信息及表达基本需求、给出指示或寻求帮助。',
      },
      {
        title: '读',
        intro:
          '能看懂一般社交场合问候语或感谢语，大体理解日常生活中常出现的、最基本的数字和字词。能够识别日常生活中最常见的标识，从表格、地图等获取基本信息。',
      },
      {
        title: '写',
        intro:
          '具备基本的书面表达能力。能书写社交场合中的简单用语，能够使用简单的词语或常用单句填写最基本的个人信息。',
      },
      { title: '译', intro: '不涉及。' },
    ],
    level2: [
      {
        title: '听',
        intro:
          '能听懂并理解与生活中常见或个人经历相关的简单话语或指示，并获取交谈中涉及的时间、地点等具体信息。能够通过手势、表情等辅助手段理解基本信息。',
      },
      {
        title: '说',
        intro:
          '能就个人或日常生活中非常熟悉的问题表达简单的指示或需求，能说出个人的基本信息。能够以简单句进行简短的问答、陈述以及社交性谈话。',
      },
      {
        title: '读',
        intro:
          '能基本认读和理解常见社交场合表示问候或邀请类等简短的文字材料， 能够从介绍性、叙述性等语言材料中获取具体的目标信息，基本读懂一般的通知、消息等。',
      },
      {
        title: '写',
        intro:
          '可以用简单的词句表达祝贺、告别等情感。能够用简单的句子介绍与个人生活或学习等密切相关的基本信息。',
      },
      { title: '译', intro: '不涉及。' },
    ],
    level3: [
      {
        title: '听',
        intro:
          '能听懂与日常生活中相关的指示、会话与交谈话语。能了解并介绍不同交谈情境下的具体信息，理解简单的故事、广告或熟悉的新闻内容。能够通过语音、语调、语速的变化等辅助手段理解和获取信息。',
      },
      {
        title: '说',
        intro:
          '能够使用少量较为复杂的句式进行简单交流或讨论。能够描述个人或日常生活中常见的活动、出现的状况或讲述简单的事件，给出简单的指示。',
      },
      {
        title: '读',
        intro:
          '能够理解简单复句，读懂叙述性、说明性等语言材料，理解文章大意和细节信息。能够利用字典、词典等，理解生词意义。',
      },
      {
        title: '写',
        intro:
          '能够理解简单复句，读懂叙述性、说明性等语言材料，理解文章大意和细节信息。能够利用字典、词典等，理解生词意义。',
      },
      { title: '译', intro: '不涉及。' },
    ],
    level4: [
      {
        title: '听',
        intro:
          '能听懂一般交际场合标准、清晰的对话，抓住主要内容，领悟说话人的重点或意图。偶尔会需要说话方重复。',
      },
      {
        title: '说',
        intro:
          '能在一般社交场合较自信地与他人交流，能参加小组讨论或做报告，就某件事情提出建议、给出理由、表达自己的观点。',
      },
      {
        title: '读',
        intro:
          '读懂叙述性、说明性等语言材料及简单的议论文，理解主要内容，把握关键信息，并做出适当推断。',
      },
      {
        title: '写',
        intro:
          '能够使用简单的句式进行语段表达，能够完成常见的应用文体写作，格式基本正确。用词准确度较高，句式有一定的变化，表达较清楚。',
      },
      {
        title: '译',
        intro:
          '具备初步的翻译能力。能够完成非正式场合的接待和简单陪同口译任务，能够翻译简单的叙述性和说明性文本，译文大体准确。',
      },
    ],
    level5: [
      {
        title: '听',
        intro: '能听懂话题熟悉但内容抽象或复杂的发言，抓住主要内容，掌握说话人的目的、态度等。',
      },
      {
        title: '说',
        intro:
          '能在多数社交和工作场合自信并有效地与他人交流。能就一般性话题在具体或抽象层面进行讲述或参与讨论。',
      },
      {
        title: '读',
        intro:
          '能理解复杂的复句，读懂有一定长度的材料或相当复杂的介绍性或说明性材料，理解、概括语言材料的中心意思或论点论据。能进行逻辑推断，较好理解所涉及的文化因素。',
      },
      {
        title: '写',
        intro:
          '能够使用较为复杂的句式进行语段表达，能够撰写一般性文章，就具体或一般性抽象话题进行描述、解释或说明，用词较为恰当，表达较为通顺。',
      },
      {
        title: '译',
        intro:
          '具备基本的翻译能力。能够完成非正式场合的简单交替传译任务，能够翻译一般的叙述性、说明性或议论性文本，能够对翻译中涉及的文化因素进行基本处理。',
      },
    ],
    level6: [
      {
        title: '听',
        intro:
          '能够规避一些方音、语病的影响，听懂各种交际活动中的对话或讲话，以及基本理解涉及的文化内容。',
      },
      {
        title: '说',
        intro: '能用中文自如地进行各种社会交际活动，中文口语水平接近母语者。',
      },
      {
        title: '读',
        intro:
          '能够厘清语言材料的结构层次，准确理解内容，摘取主要论点和信息，基本理解所涉及的文化内容。具有较强的跳读、查找信息、概括要点等阅读技能。',
      },
      {
        title: '写',
        intro:
          '能够使用较长和较为复杂的句式进行语段表达，能够完成多种应用文体写作，能够运用常见的修辞手法，内容完整，表达规范。',
      },
      {
        title: '译',
        intro:
          '具备一般的翻译能力。能够完成非正式场合的口译任务，能够翻译常见的叙述性、说明性、议论性文本，能够对翻译中涉及的文化因素进行恰当的处理。',
      },
    ],
    level7: [
      {
        title: '听',
        intro:
          '能够听懂语速正常或较快的各类语言材料。能够不受环境等因素的干扰，总结概括要点。能够理解所涉及的社会文化内涵。',
      },
      {
        title: '说',
        intro: '能够运用所学完成相关的话题表达和交际任务，发音准确，语调自然，表达得体。能够灵活运用修辞手段增强口头表达效果，体现一定的跨文化交际能力。',
      },
      {
        title: '读',
        intro:
          '能够准确且快速读懂各类文章，熟练掌握阅读技能，理解文章思想与社会内涵。',
      },
      {
        title: '写',
        intro:
          '能够手写相应篇幅的应用文、说明文、议论文和专业论文。观点明确，层次清晰，语句流畅，逻辑清楚。能够正确运用比较丰富的成语、习用语和多种修辞方法。',
      },
      {
        title: '译',
        intro:
          '具备基本的专业翻译能力。能够完成交替传译，表达流畅，符合中文表达习惯。能够翻译文章，译文通顺，格式准确。',
      }]
  },
  content_vi: {
    level1: [
      {
        title: 'Nghe',
        intro:
          'Có khả năng hiểu được một số từ ngữ, con số,từ ngữ mấu chốt liên quan đến cuộc sống thường ngày. Có thể nghe hiểu được nội dung hỏi thăm và chào hỏi, hiểu cơ bản các yêu cầu và chỉ thị lời nói.',
      },
      {
        title: 'Nói',
        intro:
          'Có năng lực biểu đạt lời nói sơ bộ, có thể trả lời câu hỏi thăm của người khác, hỏi đáp thông tin cơ bản và biểu đạt những yêu cầu cơ bản, có thể đưa ra chỉ thị hoặc yêu cầu giúp đỡ.',
      },
      {
        title: 'Đọc',
        intro:
          'Có thể đọc hiểu các từ ngữ hỏi thăm xã giao hoặc lời cảm ơn thông thường, cơ bản lý giải được các từ, con số cơ bản nhất thường thấy trong sinh hoạt hằng ngày. Có thể nhận biết được các thông tin cơ bản trong các tờ bản đồ, bảng hiểu, ký hiệu thường gặp nhất trong cuộc sống thường ngày.',
      },
      {
        title: 'Viết',
        intro:
          'Có năng lực biểu đạt văn bản viết cơ bản. Có thể viết được những từ ngữ đơn giản được dùng trong các trường hợp giao tiếp, có thể sử dụng những từ ngữ đơn giản và những câu đơn thường dùng để điền những thông tin cá nhân cơ bản nhất.',
      },
      { title: 'Dịch thuật và phiên dịch', intro: 'Không liên quan' },
    ],
    level2: [
      {
        title: 'Nghe',
        intro:
          'Có khả năng nghe hiểu và lý giải các biểu thị và từ ngữ đơn giản liên quan đến quá trình hoạt động của cá nhân hoặc thường thấy trong cuộc sống sinh hoạt, đồng thời đã được tiếp thu những thông tin cụ thể liên quan đến thời gian, địa điểm. Có thể thông qua biểu cảm, ngôn ngữ cơ thể hỗ trợ để giải thích các thông tin cơ bản.',
      },
      {
        title: 'Nói',
        intro:
          'Có thể biểu đạt các chỉ thị, yêu cầu đối với các vấn đề cá nhân hoặc những vấn đề quen thuộc thường thấy trong sinh hoạt hằng ngày, có thể nói về các thông tin cơ bản về cá nhân. Có thể dùng những câu đơn giản để tiến hành hỏi đáp ngắn, đơn giản, hoặc trần thuật để nói chuyện xã giao.',
      },
      {
        title: 'Đọc',
        intro:
          'Cơ bản đọc và hiểu được những tài liệu có từ ngữ ngắn, đơn giản biểu thị lời hỏi thăm, lời mời trong các trường hợp xã giao thường thấy. Có thể hiểu được các thông tin cụ thể trong các tài liệu ngôn ngữ liên quan đến việc giới thiệu, tự thuật. Cơ bản đọc hiểu được những tin tức, thông báo thông thường...',
      },
      {
        title: 'Viết',
        intro:
          'Bạn có thể bày tỏ lời chúc mừng, chia tay và những cảm xúc khác bằng những từ đơn giản. Có thể giới thiệu thông tin cơ bản có liên quan chặt chẽ đến cuộc sống cá nhân hoặc học tập bằng những câu đơn giản.',
      },
      { title: 'Dịch thuật và phiên dịch', intro: 'Không liên quan' },
    ],
    level3: [
      {
        title: 'Nghe',
        intro:
          ' Có thể nghe hiểu những chỉ thị, hội thoại và hội thoại giao tiếp liên quan đến cuộc sống thường ngày. Hiểu và giới thiệu được những thông tin cụ thể trong các tình huống giao tiếp khác nhau, hiểu được nội dung liên quan đến những câu chuyện, quảng cáo hoặc những tin tức quen thuộc. Có thể thông qua các biện pháp hỗ trợ như việc biến hoá về ngữ âm, ngữ điệu, ngữ tốc để hiểu và thu nhận thông tin.',
      },
      {
        title: 'Nói',
        intro:
          'Có thể sử dụng một số ít mẫu câu tương đối phức tạp để tiến hành giao lưu, thảo luận đơn giản. Có thể miêu tả những tình hình của cá nhân hoặc những hoạt động thường thấy trong cuộc sống hằng ngày hoặc kể lại những sự việc đơn giản, đưa ra được những chỉ thị đơn giản.',
      },
      {
        title: 'Đọc',
        intro:
          'Có thể đọc hiểu những câu phức đơn giản, đọc hiểu các tài liệu ngôn ngữ liên quan đến nội dung tự thuật, giải thích, hiểu được đại ý bài văn và thông tin chi tiết. Có thể sử dụng từ điển để hiểu được nghĩa các từ mới.',
      },
      {
        title: 'Viết',
        intro:
          ' Có năng lực diễn đạt văn bằng văn bản thông thường, có thể thực hiện giao tiếp bằng văn bản một cách đơn giản, có thể giản lược trần thuật về cá nhân, gia đình hoặc các kế hoạch, sự kiện thường gặp khác. Diễn đạt câu về cơ bản là rõ ràng.',
      },
      { title: 'Dịch thuật và phiên dịch', intro: 'Không liên quan' },
    ],
  level4: [
      {
        title: '听',
        intro:
          '能听懂一般交际场合标准、清晰的对话，抓住主要内容，领悟说话人的重点或意图。偶尔会需要说话方重复。',
      },
      {
        title: '说',
        intro:
          '能在一般社交场合较自信地与他人交流，能参加小组讨论或做报告，就某件事情提出建议、给出理由、表达自己的观点。',
      },
      {
        title: '读',
        intro:
          '读懂叙述性、说明性等语言材料及简单的议论文，理解主要内容，把握关键信息，并做出适当推断。',
      },
      {
        title: '写',
        intro:
          '能够使用简单的句式进行语段表达，能够完成常见的应用文体写作，格式基本正确。用词准确度较高，句式有一定的变化，表达较清楚。',
      },
      {
        title: '译',
        intro:
          '具备初步的翻译能力。能够完成非正式场合的接待和简单陪同口译任务，能够翻译简单的叙述性和说明性文本，译文大体准确。',
      },
    ],
    level5: [
      {
        title: '听',
        intro: '能听懂话题熟悉但内容抽象或复杂的发言，抓住主要内容，掌握说话人的目的、态度等。',
      },
      {
        title: '说',
        intro:
          '能在多数社交和工作场合自信并有效地与他人交流。能就一般性话题在具体或抽象层面进行讲述或参与讨论。',
      },
      {
        title: '读',
        intro:
          '能理解复杂的复句，读懂有一定长度的材料或相当复杂的介绍性或说明性材料，理解、概括语言材料的中心意思或论点论据。能进行逻辑推断，较好理解所涉及的文化因素。',
      },
      {
        title: '写',
        intro:
          '能够使用较为复杂的句式进行语段表达，能够撰写一般性文章，就具体或一般性抽象话题进行描述、解释或说明，用词较为恰当，表达较为通顺。',
      },
      {
        title: '译',
        intro:
          '具备基本的翻译能力。能够完成非正式场合的简单交替传译任务，能够翻译一般的叙述性、说明性或议论性文本，能够对翻译中涉及的文化因素进行基本处理。',
      },
    ],
    level6: [
      {
        title: '听',
        intro:
          '能够规避一些方音、语病的影响，听懂各种交际活动中的对话或讲话，以及基本理解涉及的文化内容。',
      },
      {
        title: '说',
        intro: '能用中文自如地进行各种社会交际活动，中文口语水平接近母语者。',
      },
      {
        title: '读',
        intro:
          '能够厘清语言材料的结构层次，准确理解内容，摘取主要论点和信息，基本理解所涉及的文化内容。具有较强的跳读、查找信息、概括要点等阅读技能。',
      },
      {
        title: '写',
        intro:
          '能够使用较长和较为复杂的句式进行语段表达，能够完成多种应用文体写作，能够运用常见的修辞手法，内容完整，表达规范。',
      },
      {
        title: '译',
        intro:
          '具备一般的翻译能力。能够完成非正式场合的口译任务，能够翻译常见的叙述性、说明性、议论性文本，能够对翻译中涉及的文化因素进行恰当的处理。',
      },
    ],
    level7: [
      {
        title: '听',
        intro:
          '能够听懂语速正常或较快的各类语言材料。能够不受环境等因素的干扰，总结概括要点。能够理解所涉及的社会文化内涵。',
      },
      {
        title: '说',
        intro: '能够运用所学完成相关的话题表达和交际任务，发音准确，语调自然，表达得体。能够灵活运用修辞手段增强口头表达效果，体现一定的跨文化交际能力。',
      },
      {
        title: '读',
        intro:
          '能够准确且快速读懂各类文章，熟练掌握阅读技能，理解文章思想与社会内涵。',
      },
      {
        title: '写',
        intro:
          '能够手写相应篇幅的应用文、说明文、议论文和专业论文。观点明确，层次清晰，语句流畅，逻辑清楚。能够正确运用比较丰富的成语、习用语和多种修辞方法。',
      },
      {
        title: '译',
        intro:
          '具备基本的专业翻译能力。能够完成交替传译，表达流畅，符合中文表达习惯。能够翻译文章，译文通顺，格式准确。',
      }]
  },
  content_en: {
    level1: [
      {
        title: 'Listening',
        intro:
          'Can understand key words related to daily life and numbers, etc. Can understand greetings, basic instructions or requirements.',
      },
      {
        title: 'Speaking',
        intro:
          'Has basic oral skills, including responding to greetings, asking and answering basic information, expressing basic needs, giving instructions and seeking for help.',
      },
      {
        title: 'Reading',
        intro:
          'Can understand greetings and thankings in common social situations. Can understand the most basic daily-used numbers and words. Can identify the most common signs and obtain basic information from forms, maps, etc.',
      },
      {
        title: 'Writing',
        intro:
          'Has basic writing ability. Can write simple words and sentences for social needs, and fill in basic personal information.',
      },
      { title: 'Translation and interpreting', intro: 'Not tested in HSK1&2&3.' },
    ],
    level2: [
      {
        title: 'Listening',
        intro:
          'Can understand simple words or instructions in daily life or related to personal experiences.Can acquire specific information such as time and place from conversations. Can understand basic information through gestures, facial expressions and other auxiliary means.',
      },
      {
        title: 'Speaking',
        intro:
          'Can express simple instructions or needs on familiar topics of personal matters or daily life.Can talk about basic personal information. Can make short questions, answers, statements and social conversations in simple sentences.',
      },
      {
        title: 'Reading',
        intro: `Can understand short written materials such as greetings or invitations in common social situations.Can acquire specific target information from introductory and narrative written materails.Can understand general notices and messages.`,
      },
      {
        title: 'Writing',
        intro: `Can write thank-you or farewell letters.Can introduce basic information about personal life or study with simple sentences.`,
      },
      { title: 'Translation and interpreting', intro: 'Not tested in HSK1&2&3.' },
    ],
    level3: [
      {
        title: 'Listening',
        intro: `Can understand daily instructions and conversations.Can introduce specific information in different situations.Can understand simple stories, advertisements or familiar news.Can acquire information through auxiliary means such as pronunciation, intonation and speed changes.`,
      },
      {
        title: 'Speaking',
        intro: `Can use a small number of complex sentences for simple communication or discussion.Can describe personal or common activities, situations or simple events and give simple instructions.`,
      },
      {
        title: 'Reading',
        intro: `Can understand short written materials such as greetings or invitations in common social situations.Can acquire specific target information from introductory and narrative written materails.Can understand general notices and messages.`,
      },
      {
        title: 'Writing',
        intro: `Has a general effective writing ability.Can briefly describe events and plans related to individuals, families or other familiar ones in a generally smooth and clear manner.`,
      },
      { title: 'Translation and interpreting', intro: 'Not tested in HSK1&2&3.' },
    ],
    level4: [
      {
        title: '听',
        intro:
          '能听懂一般交际场合标准、清晰的对话，抓住主要内容，领悟说话人的重点或意图。偶尔会需要说话方重复。',
      },
      {
        title: '说',
        intro:
          '能在一般社交场合较自信地与他人交流，能参加小组讨论或做报告，就某件事情提出建议、给出理由、表达自己的观点。',
      },
      {
        title: '读',
        intro:
          '读懂叙述性、说明性等语言材料及简单的议论文，理解主要内容，把握关键信息，并做出适当推断。',
      },
      {
        title: '写',
        intro:
          '能够使用简单的句式进行语段表达，能够完成常见的应用文体写作，格式基本正确。用词准确度较高，句式有一定的变化，表达较清楚。',
      },
      {
        title: '译',
        intro:
          '具备初步的翻译能力。能够完成非正式场合的接待和简单陪同口译任务，能够翻译简单的叙述性和说明性文本，译文大体准确。',
      },
    ],
    level5: [
      {
        title: '听',
        intro: '能听懂话题熟悉但内容抽象或复杂的发言，抓住主要内容，掌握说话人的目的、态度等。',
      },
      {
        title: '说',
        intro:
          '能在多数社交和工作场合自信并有效地与他人交流。能就一般性话题在具体或抽象层面进行讲述或参与讨论。',
      },
      {
        title: '读',
        intro:
          '能理解复杂的复句，读懂有一定长度的材料或相当复杂的介绍性或说明性材料，理解、概括语言材料的中心意思或论点论据。能进行逻辑推断，较好理解所涉及的文化因素。',
      },
      {
        title: '写',
        intro:
          '能够使用较为复杂的句式进行语段表达，能够撰写一般性文章，就具体或一般性抽象话题进行描述、解释或说明，用词较为恰当，表达较为通顺。',
      },
      {
        title: '译',
        intro:
          '具备基本的翻译能力。能够完成非正式场合的简单交替传译任务，能够翻译一般的叙述性、说明性或议论性文本，能够对翻译中涉及的文化因素进行基本处理。',
      },
    ],
    level6: [
      {
        title: '听',
        intro:
          '能够规避一些方音、语病的影响，听懂各种交际活动中的对话或讲话，以及基本理解涉及的文化内容。',
      },
      {
        title: '说',
        intro: '能用中文自如地进行各种社会交际活动，中文口语水平接近母语者。',
      },
      {
        title: '读',
        intro:
          '能够厘清语言材料的结构层次，准确理解内容，摘取主要论点和信息，基本理解所涉及的文化内容。具有较强的跳读、查找信息、概括要点等阅读技能。',
      },
      {
        title: '写',
        intro:
          '能够使用较长和较为复杂的句式进行语段表达，能够完成多种应用文体写作，能够运用常见的修辞手法，内容完整，表达规范。',
      },
      {
        title: '译',
        intro:
          '具备一般的翻译能力。能够完成非正式场合的口译任务，能够翻译常见的叙述性、说明性、议论性文本，能够对翻译中涉及的文化因素进行恰当的处理。',
      },
    ],
    level7: [
      {
        title: '听',
        intro:
          '能够听懂语速正常或较快的各类语言材料。能够不受环境等因素的干扰，总结概括要点。能够理解所涉及的社会文化内涵。',
      },
      {
        title: '说',
        intro: '能够运用所学完成相关的话题表达和交际任务，发音准确，语调自然，表达得体。能够灵活运用修辞手段增强口头表达效果，体现一定的跨文化交际能力。',
      },
      {
        title: '读',
        intro:
          '能够准确且快速读懂各类文章，熟练掌握阅读技能，理解文章思想与社会内涵。',
      },
      {
        title: '写',
        intro:
          '能够手写相应篇幅的应用文、说明文、议论文和专业论文。观点明确，层次清晰，语句流畅，逻辑清楚。能够正确运用比较丰富的成语、习用语和多种修辞方法。',
      },
      {
        title: '译',
        intro:
          '具备基本的专业翻译能力。能够完成交替传译，表达流畅，符合中文表达习惯。能够翻译文章，译文通顺，格式准确。',
      }]
  },
  content_ru: {
    level1: [
      {
        title: 'Аудирование',
        intro: `можно понимать ключевые слова, связанные с повседневной жизнью, цифрами и т.д. Можно понимать приветствия и поздравления и понимать основные инструктивные слова или просьбы.`,
      },
      {
        title: 'Говорение',
        intro:
          'иметь начальную вербальную способность, уметь отвечать на приветствия, задавать и отвечать на основные вопросы и выражать основные потребности, давать инструкции или просить о помощи.',
      },
      {
        title: 'Чтение',
        intro:
          'можно читать и понимать общие социальные приветствия и благодарности, а также понимать основные числа и слова, встречающиеся в повседневной жизни. Уметь определять наиболее распространенные знаки в повседневной жизни и получать основную информацию из таблиц, карт и т.д.',
      },
      {
        title: 'Письмо',
        intro:
          'иметь базовые навыки письменного общения. Уметь писать простые выражения, используемые в социальных ситуациях, и заполнять самую основную личную информацию, используя простые слова или общие фразы.',
      },
      { title: 'Перевод', intro: 'не касается.' },
    ],
    level2: [
      {
        title: 'Говорение',
        intro: `уметь понимать и осмысливать простые слова или инструкции, связанные с обычной жизнью или личным опытом, а также получать конкретную информацию о времени и месте, о которых идет речь в разговоре. Уметь понимать основную информацию с помощью жестов, мимики и других вспомогательных средств.`,
      },
      {
        title: 'Говорение',
        intro:
          'уметь давать простые инструкции или потребности по личным или очень знакомым вопросам повседневной жизни и сообщать основную личную информацию. Уметь составлять короткие вопросы и ответы, заявления и социальные разговоры, используя простые предложения.',
      },
      {
        title: 'Чтение',
        intro:
          'уметь читать и понимать короткие текстовые материалы, такие как приветствия или приглашения в обычных социальных ситуациях. Уметь получать конкретную целевую информацию из рекомендательных и повествовательных языковых материалов, а также читать и понимать общие уведомления и сообщения.',
      },
      {
        title: 'Письмо',
        intro:
          'уметь использовать простые слова и предлодения для выражения эмоций, таких как поздравления и прощания. Уметь использовать простые предложения для представления основной информации, тесно связанной с личной жизнью, учебой и т.д.',
      },
      { title: 'Перевод', intro: 'не касается.' },
    ],
    level3: [
      {
        title: 'Говорение',
        intro: `уметь понимать инструкции, диологи и разговоры, связанные с повседневной жизнью. Можно понимать и представлять конкретную информацию в различных разговорных контекстах и понимать содержание простых историй, рекламы или знакомых новостей. Можно понимать и получать информацию с помощью таких вспомогательных средств, как произношение, интонация и темп речи.`,
      },
      {
        title: 'Говорение',
        intro: `уметь использовать небольшое количество более сложных предложений для простого общения или обсуждения. Можно описывать обычные действия, ситуации, происходящие в личной или повседневной жизни, или рассказывать о простых событиях, давать простые инструкции.`,
      },
      {
        title: 'Чтение',
        intro: `уметь понимать простые сложносочиненные предложения, читать повествовательные, пояснительные и другие языковые материалы, понимать основную мысль и подробную информацию в текстах. Уметь понять значение новых слов с помощью словаря. `,
      },
      {
        title: 'Письмо',
        intro: `уметь выражать свои мысли в письменной форме в целом, вести простое письменное общение, давать краткий отчет о личных, семейных или других знакомых событиях, планах и т.д., с базовой беглостью и ясностью выражения.`,
      },
      { title: 'Перевод', intro: 'не касается.' },
    ],
    level4: [
      {
        title: '听',
        intro:
          '能听懂一般交际场合标准、清晰的对话，抓住主要内容，领悟说话人的重点或意图。偶尔会需要说话方重复。',
      },
      {
        title: '说',
        intro:
          '能在一般社交场合较自信地与他人交流，能参加小组讨论或做报告，就某件事情提出建议、给出理由、表达自己的观点。',
      },
      {
        title: '读',
        intro:
          '读懂叙述性、说明性等语言材料及简单的议论文，理解主要内容，把握关键信息，并做出适当推断。',
      },
      {
        title: '写',
        intro:
          '能够使用简单的句式进行语段表达，能够完成常见的应用文体写作，格式基本正确。用词准确度较高，句式有一定的变化，表达较清楚。',
      },
      {
        title: '译',
        intro:
          '具备初步的翻译能力。能够完成非正式场合的接待和简单陪同口译任务，能够翻译简单的叙述性和说明性文本，译文大体准确。',
      },
    ],
    level5: [
      {
        title: '听',
        intro: '能听懂话题熟悉但内容抽象或复杂的发言，抓住主要内容，掌握说话人的目的、态度等。',
      },
      {
        title: '说',
        intro:
          '能在多数社交和工作场合自信并有效地与他人交流。能就一般性话题在具体或抽象层面进行讲述或参与讨论。',
      },
      {
        title: '读',
        intro:
          '能理解复杂的复句，读懂有一定长度的材料或相当复杂的介绍性或说明性材料，理解、概括语言材料的中心意思或论点论据。能进行逻辑推断，较好理解所涉及的文化因素。',
      },
      {
        title: '写',
        intro:
          '能够使用较为复杂的句式进行语段表达，能够撰写一般性文章，就具体或一般性抽象话题进行描述、解释或说明，用词较为恰当，表达较为通顺。',
      },
      {
        title: '译',
        intro:
          '具备基本的翻译能力。能够完成非正式场合的简单交替传译任务，能够翻译一般的叙述性、说明性或议论性文本，能够对翻译中涉及的文化因素进行基本处理。',
      },
    ],
    level6: [
      {
        title: '听',
        intro:
          '能够规避一些方音、语病的影响，听懂各种交际活动中的对话或讲话，以及基本理解涉及的文化内容。',
      },
      {
        title: '说',
        intro: '能用中文自如地进行各种社会交际活动，中文口语水平接近母语者。',
      },
      {
        title: '读',
        intro:
          '能够厘清语言材料的结构层次，准确理解内容，摘取主要论点和信息，基本理解所涉及的文化内容。具有较强的跳读、查找信息、概括要点等阅读技能。',
      },
      {
        title: '写',
        intro:
          '能够使用较长和较为复杂的句式进行语段表达，能够完成多种应用文体写作，能够运用常见的修辞手法，内容完整，表达规范。',
      },
      {
        title: '译',
        intro:
          '具备一般的翻译能力。能够完成非正式场合的口译任务，能够翻译常见的叙述性、说明性、议论性文本，能够对翻译中涉及的文化因素进行恰当的处理。',
      },
    ],
    level7: [
      {
        title: '听',
        intro:
          '能够听懂语速正常或较快的各类语言材料。能够不受环境等因素的干扰，总结概括要点。能够理解所涉及的社会文化内涵。',
      },
      {
        title: '说',
        intro: '能够运用所学完成相关的话题表达和交际任务，发音准确，语调自然，表达得体。能够灵活运用修辞手段增强口头表达效果，体现一定的跨文化交际能力。',
      },
      {
        title: '读',
        intro:
          '能够准确且快速读懂各类文章，熟练掌握阅读技能，理解文章思想与社会内涵。',
      },
      {
        title: '写',
        intro:
          '能够手写相应篇幅的应用文、说明文、议论文和专业论文。观点明确，层次清晰，语句流畅，逻辑清楚。能够正确运用比较丰富的成语、习用语和多种修辞方法。',
      },
      {
        title: '译',
        intro:
          '具备基本的专业翻译能力。能够完成交替传译，表达流畅，符合中文表达习惯。能够翻译文章，译文通顺，格式准确。',
      }]
  },
  content_ja: {
    level1: [
      {
        title: '聞く',
        intro:
          '日常生活で用いられる単語や数字などの言葉を簡単に理解でき、あいさつや基本的な指示と要求が聞き取れる。',
      },
      {
        title: '話す',
        intro:
          '最も基本的な話し能力を備える。相手からの挨拶や簡単な質問に対して対応でき、基本的な要求や指示を出すこと、または助力を求めることができる。',
      },
      {
        title: '読む',
        intro:
          '一般の場合で現れた挨拶や感謝の言葉が読み取れる。日常生活でよく見られた基本的な数字や文字と単語をだいたい理解できる。またよく現れた標識の意味が知り、表や地図などから基本的な情報をつかむことができる。',
      },
      {
        title: '書く',
        intro:
          '基本的な書く能力を備える。簡単な交際用語を書け、簡単な単語や言葉で個人情報を書き入れることができる。',
      },
      { title: '訳す', intro: '考察しない' },
    ],
    level2: [
      {
        title: '聞く',
        intro:
          '日常生活でよく出たことや自分の経歴に関する簡単な言葉や指示について理解することができ、、会話中の時間や場所などの情報を得ることができる。ジェスチャーや表情などの補助方式によって、基本的な情報を理解することができる。',
      },
      {
        title: '話す',
        intro:
          '個人や日常に関するすでに熟知された内容に対して、簡単な指示や要求を出せ、基本的な個人情報が話す。簡単な文型で回答や叙述、社交的な会話が対応できる。',
      },
      {
        title: '読む',
        intro:
          '社交的な場合でよくある挨拶や誘うための短文などの内容を読むまた理解することができる。説明文や叙事文などのテキストから特定な情報内容を手に入り、普通のお知らせやメッセージなどの内容を理解できる。',
      },
      {
        title: '書く',
        intro:
          '簡単な言葉で祝福や別れの気持ちを伝える。簡単な文節で、自らの生活や勉強に関する基本的な状況を紹介することができる。',
      },
      { title: '訳す', intro: '考察しない' },
    ],
    level3: [
      {
        title: '聞く',
        intro:
          '日常生活で出てきた指示や会話の内容を聞き取れる。会話のシーンによって詳しい情報が理解・説明することができ、内容の簡単な物語やCMまた熟知するニュースを理解でき、喋る時の語音・語調・速度の変化などの補助方式によって、情報を得てまた理解することができる。',
      },
      {
        title: '話す',
        intro:
          'より複雑な文型で少し簡単な会話や議論ができる。個人や日常でよく出た活動や状況について話せ、簡単な事を紹介でき、易く指示を出すことができる。',
      },
      {
        title: '読む',
        intro:
          '簡単な複文を理解でき、叙述文や説明文などのテキストを読み取れ、文章の大体の意味や細かい所を理解することができる。また字典や辞書を利用して知らない言葉の意味を調べることができる。',
      },
      {
        title: '書く',
        intro:
          '一般的な書く能力を備え、文字を使って簡単な交流ができる。個人や家族また熟知することについての状況や計画を文章で簡単に紹介でき、文章に内容的・文法的な誤りがほぼない。',
      },
      { title: '訳す', intro: '考察しない' },
    ],
    level4: [
      {
        title: '听',
        intro:
          '能听懂一般交际场合标准、清晰的对话，抓住主要内容，领悟说话人的重点或意图。偶尔会需要说话方重复。',
      },
      {
        title: '说',
        intro:
          '能在一般社交场合较自信地与他人交流，能参加小组讨论或做报告，就某件事情提出建议、给出理由、表达自己的观点。',
      },
      {
        title: '读',
        intro:
          '读懂叙述性、说明性等语言材料及简单的议论文，理解主要内容，把握关键信息，并做出适当推断。',
      },
      {
        title: '写',
        intro:
          '能够使用简单的句式进行语段表达，能够完成常见的应用文体写作，格式基本正确。用词准确度较高，句式有一定的变化，表达较清楚。',
      },
      {
        title: '译',
        intro:
          '具备初步的翻译能力。能够完成非正式场合的接待和简单陪同口译任务，能够翻译简单的叙述性和说明性文本，译文大体准确。',
      },
    ],
    level5: [
      {
        title: '听',
        intro: '能听懂话题熟悉但内容抽象或复杂的发言，抓住主要内容，掌握说话人的目的、态度等。',
      },
      {
        title: '说',
        intro:
          '能在多数社交和工作场合自信并有效地与他人交流。能就一般性话题在具体或抽象层面进行讲述或参与讨论。',
      },
      {
        title: '读',
        intro:
          '能理解复杂的复句，读懂有一定长度的材料或相当复杂的介绍性或说明性材料，理解、概括语言材料的中心意思或论点论据。能进行逻辑推断，较好理解所涉及的文化因素。',
      },
      {
        title: '写',
        intro:
          '能够使用较为复杂的句式进行语段表达，能够撰写一般性文章，就具体或一般性抽象话题进行描述、解释或说明，用词较为恰当，表达较为通顺。',
      },
      {
        title: '译',
        intro:
          '具备基本的翻译能力。能够完成非正式场合的简单交替传译任务，能够翻译一般的叙述性、说明性或议论性文本，能够对翻译中涉及的文化因素进行基本处理。',
      },
    ],
    level6: [
      {
        title: '听',
        intro:
          '能够规避一些方音、语病的影响，听懂各种交际活动中的对话或讲话，以及基本理解涉及的文化内容。',
      },
      {
        title: '说',
        intro: '能用中文自如地进行各种社会交际活动，中文口语水平接近母语者。',
      },
      {
        title: '读',
        intro:
          '能够厘清语言材料的结构层次，准确理解内容，摘取主要论点和信息，基本理解所涉及的文化内容。具有较强的跳读、查找信息、概括要点等阅读技能。',
      },
      {
        title: '写',
        intro:
          '能够使用较长和较为复杂的句式进行语段表达，能够完成多种应用文体写作，能够运用常见的修辞手法，内容完整，表达规范。',
      },
      {
        title: '译',
        intro:
          '具备一般的翻译能力。能够完成非正式场合的口译任务，能够翻译常见的叙述性、说明性、议论性文本，能够对翻译中涉及的文化因素进行恰当的处理。',
      },
    ],
    level7: [
      {
        title: '听',
        intro:
          '能够听懂语速正常或较快的各类语言材料。能够不受环境等因素的干扰，总结概括要点。能够理解所涉及的社会文化内涵。',
      },
      {
        title: '说',
        intro: '能够运用所学完成相关的话题表达和交际任务，发音准确，语调自然，表达得体。能够灵活运用修辞手段增强口头表达效果，体现一定的跨文化交际能力。',
      },
      {
        title: '读',
        intro:
          '能够准确且快速读懂各类文章，熟练掌握阅读技能，理解文章思想与社会内涵。',
      },
      {
        title: '写',
        intro:
          '能够手写相应篇幅的应用文、说明文、议论文和专业论文。观点明确，层次清晰，语句流畅，逻辑清楚。能够正确运用比较丰富的成语、习用语和多种修辞方法。',
      },
      {
        title: '译',
        intro:
          '具备基本的专业翻译能力。能够完成交替传译，表达流畅，符合中文表达习惯。能够翻译文章，译文通顺，格式准确。',
      }]
  },
  content_ko: {
    level1: [
      {
        title: '듣기',
        intro:
          '일상생활, 숫자 등 주제에 관련된 내용을 이해할 수 있다. 인사말, 명령어, 요구에 관련된 내용을 알아들 수 있다.',
      },
      {
        title: '말하기',
        intro:
          '기초적인 생활문구를 이해하고 구사할 수 있다. 기초적인 정보에 관련된 대화를 할 수 있으며 도움 요청을 할 수 있다.',
      },
      {
        title: '읽기',
        intro:
          '사회적인 상황에서의 안부인사 또는 감사인사를 이해할 수 있다. 일상생활에서 자주 보이는 숫자, 단어 등을 알아볼 수 있다. 간단한 표식을 알아볼 수 있으며 도표에서 기본적인 정보를 발췌해낼 수 있다.   ',
      },
      {
        title: '쓰기',
        intro:
          '기본적인 표현 능력을 지니고 있다. 사회생활에서의 간단한 용어들을 쓸 수 있고 간단한 단어 및 자주 쓰이는 문장으로 개인정보를 표현할 수 있다.',
      },
      { title: '번역', intro: '없음' },
    ],
    level2: [
      {
        title: '듣기',
        intro:
          '자주 접하는 사회적 개인경험에 관련된 간단한 문구나 지시를 알아들을 수 있으며 대화하는 과정에서 언급된 시간, 장소 등 구체적인 기본정보를 알아들을 수 있다. 제스처나 표정 등 비언어적인 수단으로도 기본적인 정보를 이해할 수 있다. ',
      },
      {
        title: '말하기',
        intro:
          ' 개인 또는 일상생활에서 간단한 지시 혹은 수요를 얘기할 수 있고 개인의 기본적인 정보를 답할 수 있다. 짧은 문장으로 간단하게 묻거나 답할 수 있으며 사회적 상황에서 얘기 나눌 수 있다. ',
      },
      {
        title: '읽기',
        intro:
          '사회적인 장소에서의 안부인사 또는 초청 등 간단한 문구를 읽고 이해할 수 있고 소개성, 서술형 등 문장에서 필요한 정보를 얻어낼 수 있다. 통지문 또는 메시지 등을 이해할 수 있다.',
      },
      {
        title: '쓰기',
        intro:
          '간단한 단어나 문장으로 축하 혹은 작별 등 감정을 표현할 수 있고 간단한 문장으로 생활이나 학습에 관련된 개인상황을 공유할 수 있다.',
      },
      { title: '번역', intro: '없음' },
    ],
    level3: [
      {
        title: '듣기',
        intro:
          '일상생활과 관련된 지시, 대화 등을 알아들을 수 있고 분위기에 따라 정보를 이해하고 설명할 수 있다. 간단한 이야기나 광고 또는 신문, 뉴스 등을 이해할 수 있고 음성, 어조와 말하는 속도의 변화에 따라 정보를 획득할 수 있다. ',
      },
      {
        title: '말하기',
        intro:
          '조금 복잡한 문구로 간단한 교류나 토론을 할 수 있다. 개인이나 일상생활에서 자주 볼 수 있는 활동 또는 상활에 대해 간단하게 구사할 수 있으며 거기에 따른 간단한 지시를 내릴 수 있다.  ',
      },
      {
        title: '읽기',
        intro:
          '간단한 복합문을 이해할 수 있고 서술형, 설명형인 지문을 읽을 수 있으며 문장의 대체적인 뜻과 구체적인 정보를 이해할 수 있다. 사전을 이용하여 생소한 단어를 이해할 수 있다.',
      },
      {
        title: '쓰기',
        intro:
          '일반적인 표현능력을 가지고 있다. 간단하게 서면으로 교류가 가능하며 개인, 가정 또는 기타 익숙한 사건, 계획 등에 대해 간략하게 서술할 수 있다. 전체적으로 문장언어가 유창하며 표현하려는 바가 명확하다. ',
      },
      { title: '번역', intro: '없음' },
    ],
    level4: [
      {
        title: '听',
        intro:
          '能听懂一般交际场合标准、清晰的对话，抓住主要内容，领悟说话人的重点或意图。偶尔会需要说话方重复。',
      },
      {
        title: '说',
        intro:
          '能在一般社交场合较自信地与他人交流，能参加小组讨论或做报告，就某件事情提出建议、给出理由、表达自己的观点。',
      },
      {
        title: '读',
        intro:
          '读懂叙述性、说明性等语言材料及简单的议论文，理解主要内容，把握关键信息，并做出适当推断。',
      },
      {
        title: '写',
        intro:
          '能够使用简单的句式进行语段表达，能够完成常见的应用文体写作，格式基本正确。用词准确度较高，句式有一定的变化，表达较清楚。',
      },
      {
        title: '译',
        intro:
          '具备初步的翻译能力。能够完成非正式场合的接待和简单陪同口译任务，能够翻译简单的叙述性和说明性文本，译文大体准确。',
      },
    ],
    level5: [
      {
        title: '听',
        intro: '能听懂话题熟悉但内容抽象或复杂的发言，抓住主要内容，掌握说话人的目的、态度等。',
      },
      {
        title: '说',
        intro:
          '能在多数社交和工作场合自信并有效地与他人交流。能就一般性话题在具体或抽象层面进行讲述或参与讨论。',
      },
      {
        title: '读',
        intro:
          '能理解复杂的复句，读懂有一定长度的材料或相当复杂的介绍性或说明性材料，理解、概括语言材料的中心意思或论点论据。能进行逻辑推断，较好理解所涉及的文化因素。',
      },
      {
        title: '写',
        intro:
          '能够使用较为复杂的句式进行语段表达，能够撰写一般性文章，就具体或一般性抽象话题进行描述、解释或说明，用词较为恰当，表达较为通顺。',
      },
      {
        title: '译',
        intro:
          '具备基本的翻译能力。能够完成非正式场合的简单交替传译任务，能够翻译一般的叙述性、说明性或议论性文本，能够对翻译中涉及的文化因素进行基本处理。',
      },
    ],
    level6: [
      {
        title: '听',
        intro:
          '能够规避一些方音、语病的影响，听懂各种交际活动中的对话或讲话，以及基本理解涉及的文化内容。',
      },
      {
        title: '说',
        intro: '能用中文自如地进行各种社会交际活动，中文口语水平接近母语者。',
      },
      {
        title: '读',
        intro:
          '能够厘清语言材料的结构层次，准确理解内容，摘取主要论点和信息，基本理解所涉及的文化内容。具有较强的跳读、查找信息、概括要点等阅读技能。',
      },
      {
        title: '写',
        intro:
          '能够使用较长和较为复杂的句式进行语段表达，能够完成多种应用文体写作，能够运用常见的修辞手法，内容完整，表达规范。',
      },
      {
        title: '译',
        intro:
          '具备一般的翻译能力。能够完成非正式场合的口译任务，能够翻译常见的叙述性、说明性、议论性文本，能够对翻译中涉及的文化因素进行恰当的处理。',
      },
    ],
    level7: [
      {
        title: '听',
        intro:
          '能够听懂语速正常或较快的各类语言材料。能够不受环境等因素的干扰，总结概括要点。能够理解所涉及的社会文化内涵。',
      },
      {
        title: '说',
        intro: '能够运用所学完成相关的话题表达和交际任务，发音准确，语调自然，表达得体。能够灵活运用修辞手段增强口头表达效果，体现一定的跨文化交际能力。',
      },
      {
        title: '读',
        intro:
          '能够准确且快速读懂各类文章，熟练掌握阅读技能，理解文章思想与社会内涵。',
      },
      {
        title: '写',
        intro:
          '能够手写相应篇幅的应用文、说明文、议论文和专业论文。观点明确，层次清晰，语句流畅，逻辑清楚。能够正确运用比较丰富的成语、习用语和多种修辞方法。',
      },
      {
        title: '译',
        intro:
          '具备基本的专业翻译能力。能够完成交替传译，表达流畅，符合中文表达习惯。能够翻译文章，译文通顺，格式准确。',
      }]
  },
  content_th: {
    level1: [
      {
        title: 'การฟัง',
        intro:
          'สามารถเข้าใจคำศัพท์ที่ใช้บ่อยในชีวิตประจำวัน ตัวเลข ฯลฯ ได้ในระดับเบื้องต้น สามารถเข้าใจการถามสารทุกข์สุกดิบ การพูดทักทายและเข้าใจคำแนะนำหรือข้อกำหนดพื้นฐาน',
      },
      {
        title: 'การพูด',
        intro:
          'มีทักษะการแสดงออกด้วยภาษาพูดในระดับเบื้องต้น สามารถตอบรับการทักทายของผู้อื่น ทักถามและตอบรับข้อมูลพื้นฐานและแสดงความต้องการขั้นพื้นฐาน ให้คำแนะนำหรือขอความช่วยเหลือ',
      },
      {
        title: 'การอ่าน',
        intro:
          'สามารถเข้าใจการพูดทักทายหรือการกล่าวขอบคุณในโอกาสต่าง ๆ ของทางสังคมทั่วไป เข้าใจตัวเลขและคำศัพท์พื้นฐานที่ใช้บ่อยในชีวิตประจำวัน เข้าใจสัญญาณที่พบบ่อยที่สุดในชีวิตประจำวัน และรับข้อมูลพื้นฐานจากตาราง แผนที่ ฯลฯ',
      },
      {
        title: 'การเขียน',
        intro:
          'มีทักษะการเขียนขั้นพื้นฐาน สามารถเขียนคำศัพท์ง่าย ๆ ในโอกาสต่าง ๆ ของทางสังคม สามารถใช้คำศัพท์ง่าย ๆ หรือเอกรรถประโยคทั่วไปเพื่อกรอกข้อมูลส่วนตัวพื้นฐานได้',
      },
      { title: 'การแปล', intro: 'ไม่ได้ใช้' },
    ],
    level2: [
      {
        title: 'การฟัง',
        intro:
          'สามารถเข้าใจคำศัพท์หรือแนะนำง่าย ๆ ที่ใช้บ่อยในชีวิตประจำวันหรือเกี่ยวข้องกับประสบการณ์ส่วนตัว และรับรายละเอียดข้อมูลเช่นเวลาและสถานที่ที่เกี่ยวข้องกับการสนทนา สามารถเข้าใจข้อมูลพื้นฐานผ่านวิธีการเสริม เช่น ท่าทางและการแสดงออกทางสีหน้า',
      },
      {
        title: 'การพูด',
        intro:
          'สามารถแสดงคำแนะนำหรือความต้องการง่าย ๆ เกี่ยวกับปัญหาส่วนตัวหรือปัญหาที่คุ้นเคยในชีวิตประจำวัน และสามารถบอกกล่าวข้อมูลส่วนตัวขั้นพื้นฐานได้ สามารถทักถามและตอบรับ กล่าวประโยคแบบสั้น ๆ และการสนทนาทางสังคมทั่วไป',
      },
      {
        title: 'การอ่าน',
        intro:
          'สามารถอ่านและเข้าใจข้อความสั้น ๆ ที่แสดงการทักทายหรือการเชิญชวนในโอกาสต่าง ๆ ของทางสังคมทั่วไปได้ในขั้นพื้นฐาน สามารถรับข้อมูลที่เป็นเป้าหมายเฉพาะจากเอกสารที่เป็นข้อมูลเบื้องต้นและเอกสารประกอบการบรรยาย ฯลฯ สามารถอ่านและเข้าใจการแจ้งเตือนข้อความ ฯลฯ โดยพื้นฐาน',
      },
      {
        title: 'การเขียน',
        intro:
          'สามารถแสดงอารมณ์ความยินดีและกล่าวอำลาด้วยคำศัพท์ง่าย ๆ สามารถแนะนำข้อมูลพื้นฐานที่เกี่ยวข้องกับชีวิตส่วนตัวอย่างใกล้ชิดหรือชีวิตการเรียนเป็นประโยคง่าย ๆ ',
      },
      { title: 'การแปล', intro: 'ไม่ได้ใช้' },
    ],
    level3: [
      {
        title: 'การฟัง',
        intro:
          'สามารถเข้าใจการแนะนำและการสนทนาที่เกี่ยวข้องกับชีวิตประจำวัน สามารถเข้าใจและแนะนำข้อมูลเฉพาะในสถานการณ์การสนทนาต่าง ๆ เข้าใจเรื่องราวสั้น ๆ  โฆษณา หรือเนื้อหาข่าวที่คุ้นเคย สามารถเข้าใจและรับข้อมูลด้วยวิธีการเสริม เช่น การเปลี่ยนแปลงของน้ำเสียงและความเร็วในการพูด',
      },
      {
        title: 'การพูด',
        intro:
          'สามารถใช้ประโยคบางส่วนที่ค่อนข้างซับซ้อนในการสื่อสารหรือการอภิปราย สามารถอธิบายกิจกรรมทั่วไป สถานการณ์ที่เกิดขึ้น หรือเหตุการณ์ง่าย ๆ ในชีวิตส่วนตัวหรือชีวิตประจำวัน และให้คำแนะนำง่าย ๆ ได้',
      },
      {
        title: 'การอ่าน',
        intro:
          'สามารถเข้าใจอเนกรรถประโยคง่าย ๆ อ่านเอกสารที่เป็นการบรรยายและการอธิบายได้ เข้าใจใจความหลักและรายละเอียดของบทความ สามารถใช้พจนานุกรม เพื่อทำความเข้าใจความหมายของคำศัพท์ใหม่',
      },
      {
        title: 'การเขียน',
        intro:
          'มีความสามารถในการแสดงออกทางการเขียนทั่วไป สามารถสื่อสารเป็นลายลักษณ์อักษรในระดับเบื้องต้น สามารถอธิบายสั้น ๆ เกี่ยวกับเหตุการณ์ แผนงานที่คุ้นเคย ฯลฯ ซึ่งเกี่ยวกับส่วนตัว ครอบครัวหรืออื่น ๆ ประโยคถูกต้องและแสดงความหมายที่ชัดเจน ',
      },
      { title: 'การแปล', intro: 'ไม่ได้ใช้' },
    ],
    level4: [
      {
        title: '听',
        intro:
          '能听懂一般交际场合标准、清晰的对话，抓住主要内容，领悟说话人的重点或意图。偶尔会需要说话方重复。',
      },
      {
        title: '说',
        intro:
          '能在一般社交场合较自信地与他人交流，能参加小组讨论或做报告，就某件事情提出建议、给出理由、表达自己的观点。',
      },
      {
        title: '读',
        intro:
          '读懂叙述性、说明性等语言材料及简单的议论文，理解主要内容，把握关键信息，并做出适当推断。',
      },
      {
        title: '写',
        intro:
          '能够使用简单的句式进行语段表达，能够完成常见的应用文体写作，格式基本正确。用词准确度较高，句式有一定的变化，表达较清楚。',
      },
      {
        title: '译',
        intro:
          '具备初步的翻译能力。能够完成非正式场合的接待和简单陪同口译任务，能够翻译简单的叙述性和说明性文本，译文大体准确。',
      },
    ],
    level5: [
      {
        title: '听',
        intro: '能听懂话题熟悉但内容抽象或复杂的发言，抓住主要内容，掌握说话人的目的、态度等。',
      },
      {
        title: '说',
        intro:
          '能在多数社交和工作场合自信并有效地与他人交流。能就一般性话题在具体或抽象层面进行讲述或参与讨论。',
      },
      {
        title: '读',
        intro:
          '能理解复杂的复句，读懂有一定长度的材料或相当复杂的介绍性或说明性材料，理解、概括语言材料的中心意思或论点论据。能进行逻辑推断，较好理解所涉及的文化因素。',
      },
      {
        title: '写',
        intro:
          '能够使用较为复杂的句式进行语段表达，能够撰写一般性文章，就具体或一般性抽象话题进行描述、解释或说明，用词较为恰当，表达较为通顺。',
      },
      {
        title: '译',
        intro:
          '具备基本的翻译能力。能够完成非正式场合的简单交替传译任务，能够翻译一般的叙述性、说明性或议论性文本，能够对翻译中涉及的文化因素进行基本处理。',
      },
    ],
    level6: [
      {
        title: '听',
        intro:
          '能够规避一些方音、语病的影响，听懂各种交际活动中的对话或讲话，以及基本理解涉及的文化内容。',
      },
      {
        title: '说',
        intro: '能用中文自如地进行各种社会交际活动，中文口语水平接近母语者。',
      },
      {
        title: '读',
        intro:
          '能够厘清语言材料的结构层次，准确理解内容，摘取主要论点和信息，基本理解所涉及的文化内容。具有较强的跳读、查找信息、概括要点等阅读技能。',
      },
      {
        title: '写',
        intro:
          '能够使用较长和较为复杂的句式进行语段表达，能够完成多种应用文体写作，能够运用常见的修辞手法，内容完整，表达规范。',
      },
      {
        title: '译',
        intro:
          '具备一般的翻译能力。能够完成非正式场合的口译任务，能够翻译常见的叙述性、说明性、议论性文本，能够对翻译中涉及的文化因素进行恰当的处理。',
      },
    ],
    level7: [{
        title: '听',
        intro:
          '能够听懂语速正常或较快的各类语言材料。能够不受环境等因素的干扰，总结概括要点。能够理解所涉及的社会文化内涵。',
      },
      {
        title: '说',
        intro: '能够运用所学完成相关的话题表达和交际任务，发音准确，语调自然，表达得体。能够灵活运用修辞手段增强口头表达效果，体现一定的跨文化交际能力。',
      },
      {
        title: '读',
        intro:
          '能够准确且快速读懂各类文章，熟练掌握阅读技能，理解文章思想与社会内涵。',
      },
      {
        title: '写',
        intro:
          '能够手写相应篇幅的应用文、说明文、议论文和专业论文。观点明确，层次清晰，语句流畅，逻辑清楚。能够正确运用比较丰富的成语、习用语和多种修辞方法。',
      },
      {
        title: '译',
        intro:
          '具备基本的专业翻译能力。能够完成交替传译，表达流畅，符合中文表达习惯。能够翻译文章，译文通顺，格式准确。',
      }]
  },
   content_fr: {
    level1: [
      {
        title: 'Écouter',
        intro:
          'Capable de comprendre simplement les mots-clés liés à la vie quotidienne, aux nombres, etc. Pouvoir comprendre les salutations et les accueils, saisir les instructions ou demandes de base.',
      },
      {
        title: 'Discours',
        intro:
          "Posséder des capacités d'expression orale élémentaires, capable de répondre aux salutations d'autrui, de poser et de répondre aux questions d'informations de base, d'exprimer des besoins essentiels, de donner des instructions ou de demander de l'aide.",
      },
      {
        title: 'Lire',
        intro:
          'Capable de comprendre les salutations ou les remerciements dans des situations sociales courantes, de saisir globalement les nombres et mots les plus basiques dans la vie quotidienne. Peut reconnaître les signes les plus courants dans la vie quotidienne, obtenir des informations de base à partir de tableaux, de cartes, etc.',
      },
      {
        title: 'Écrire',
        intro:
          "Posséder des capacités d'expression écrite de base. Capable d'écrire des phrases simples dans des situations sociales, de remplir des informations personnelles de base en utilisant des mots simples ou des phrases courantes.",
      },
      { title: 'Traduction et interprétation', intro: 'Non concerné.' },
    ],
    level2: [
      {
        title: 'Écouter',
        intro:
          "Capable de comprendre et de saisir des phrases simples ou des instructions liées à des expériences personnelles courantes dans la vie, et d'obtenir des informations spécifiques telles que le temps, le lieu mentionnés dans la conversation. Pouvoir comprendre les informations de base avec l'aide de gestes, d'expressions faciales, etc.",
      },
      {
        title: 'Discours',
        intro:
          "Capable d'exprimer des instructions ou des besoins simples concernant des questions personnelles ou très familières de la vie quotidienne, de dire des informations personnelles de base. Capable de mener des échanges simples, des déclarations et des conversations sociales avec des phrases simples.",
      },
      {
        title: 'Lire',
        intro: 'Pouvoir lire et comprendre des matériaux écrits courts et courants dans des situations sociales, tels que des salutations ou des invitations. Capable de tirer des informations ciblées de matériaux descriptifs ou narratifs, de comprendre en général des avis, des messages, etc.',
      },
      {
        title: 'Écrire',
        intro: `Capable d'exprimer des sentiments comme des félicitations ou des adieux avec des phrases simples. Pouvoir introduire des informations personnelles de base étroitement liées à la vie personnelle ou aux études avec des phrases simples.`,
      },
      { title: 'Traduction et interprétation', intro: 'Non concerné.' },
    ],
    level3: [
      {
        title: 'Écouter',
        intro: `Capable de comprendre des instructions, des conversations et des dialogues liés à la vie quotidienne. Pouvoir comprendre et présenter des informations spécifiques dans différents contextes de conversation, comprendre des histoires simples, des publicités ou des nouvelles familières. Capable de comprendre et d'obtenir des informations grâce à des moyens auxiliaires tels que la tonalité, l'intonation, le rythme de la parole.`,
      },
      {
        title: 'Discours',
        intro: `Capable de communiquer ou de discuter simplement en utilisant quelques structures de phrases plus complexes. Pouvoir décrire des activités personnelles ou courantes, des situations rencontrées ou raconter des événements simples, donner des instructions simples.`,
      },
      {
        title: 'Lire',
        intro: `Capable de comprendre des propositions grammaticales simples, de lire et de comprendre des documents narratifs ou explicatifs, de comprendre l'idée principale et les détails d'un texte. Capable d'utiliser un dictionnaire pour comprendre la signification des mots inconnus.`,
      },
      {
        title: 'Écrire',
        intro: `Posséder des compétences d'expression écrite générales, capable de communiquer par écrit simplement, de relater brièvement des événements ou des projets liés à la personne, à la famille ou à d'autres sujets familiers; les phrases sont généralement cohérentes et l'expression est claire.`,
      },
      { title: 'Traduction et interprétation', intro: 'Non concerné.' },
    ],
    level4: [
      {
        title: '听',
        intro:
          '能听懂一般交际场合标准、清晰的对话，抓住主要内容，领悟说话人的重点或意图。偶尔会需要说话方重复。',
      },
      {
        title: '说',
        intro:
          '能在一般社交场合较自信地与他人交流，能参加小组讨论或做报告，就某件事情提出建议、给出理由、表达自己的观点。',
      },
      {
        title: '读',
        intro:
          '读懂叙述性、说明性等语言材料及简单的议论文，理解主要内容，把握关键信息，并做出适当推断。',
      },
      {
        title: '写',
        intro:
          '能够使用简单的句式进行语段表达，能够完成常见的应用文体写作，格式基本正确。用词准确度较高，句式有一定的变化，表达较清楚。',
      },
      {
        title: '译',
        intro:
          '具备初步的翻译能力。能够完成非正式场合的接待和简单陪同口译任务，能够翻译简单的叙述性和说明性文本，译文大体准确。',
      },
    ],
    level5: [
      {
        title: '听',
        intro: '能听懂话题熟悉但内容抽象或复杂的发言，抓住主要内容，掌握说话人的目的、态度等。',
      },
      {
        title: '说',
        intro:
          '能在多数社交和工作场合自信并有效地与他人交流。能就一般性话题在具体或抽象层面进行讲述或参与讨论。',
      },
      {
        title: '读',
        intro:
          '能理解复杂的复句，读懂有一定长度的材料或相当复杂的介绍性或说明性材料，理解、概括语言材料的中心意思或论点论据。能进行逻辑推断，较好理解所涉及的文化因素。',
      },
      {
        title: '写',
        intro:
          '能够使用较为复杂的句式进行语段表达，能够撰写一般性文章，就具体或一般性抽象话题进行描述、解释或说明，用词较为恰当，表达较为通顺。',
      },
      {
        title: '译',
        intro:
          '具备基本的翻译能力。能够完成非正式场合的简单交替传译任务，能够翻译一般的叙述性、说明性或议论性文本，能够对翻译中涉及的文化因素进行基本处理。',
      },
    ],
    level6: [
      {
        title: '听',
        intro:
          '能够规避一些方音、语病的影响，听懂各种交际活动中的对话或讲话，以及基本理解涉及的文化内容。',
      },
      {
        title: '说',
        intro: '能用中文自如地进行各种社会交际活动，中文口语水平接近母语者。',
      },
      {
        title: '读',
        intro:
          '能够厘清语言材料的结构层次，准确理解内容，摘取主要论点和信息，基本理解所涉及的文化内容。具有较强的跳读、查找信息、概括要点等阅读技能。',
      },
      {
        title: '写',
        intro:
          '能够使用较长和较为复杂的句式进行语段表达，能够完成多种应用文体写作，能够运用常见的修辞手法，内容完整，表达规范。',
      },
      {
        title: '译',
        intro:
          '具备一般的翻译能力。能够完成非正式场合的口译任务，能够翻译常见的叙述性、说明性、议论性文本，能够对翻译中涉及的文化因素进行恰当的处理。',
      },
     ],
     level7: [
       {
        title: '听',
        intro:
          '能够听懂语速正常或较快的各类语言材料。能够不受环境等因素的干扰，总结概括要点。能够理解所涉及的社会文化内涵。',
      },
      {
        title: '说',
        intro: '能够运用所学完成相关的话题表达和交际任务，发音准确，语调自然，表达得体。能够灵活运用修辞手段增强口头表达效果，体现一定的跨文化交际能力。',
      },
      {
        title: '读',
        intro:
          '能够准确且快速读懂各类文章，熟练掌握阅读技能，理解文章思想与社会内涵。',
      },
      {
        title: '写',
        intro:
          '能够手写相应篇幅的应用文、说明文、议论文和专业论文。观点明确，层次清晰，语句流畅，逻辑清楚。能够正确运用比较丰富的成语、习用语和多种修辞方法。',
      },
      {
        title: '译',
        intro:
          '具备基本的专业翻译能力。能够完成交替传译，表达流畅，符合中文表达习惯。能够翻译文章，译文通顺，格式准确。',
      }]
  },
  content_mn: {
    level1: [
      {
        title: '听',
        intro:
          'Өдөр тутмын хэрэглээ, тоо хэмжээ гэх мэттэй холбоотой гол нэр томьёог хялбархан ойлгож чадна. Мэнд мэдэх, мэндчилэх мөн үндсэн зааварчилгаа болон шаардлагыг ойлгох чадвартай.',
      },
      {
        title: '说',
        intro:
          'Анхан шатны аман ярианы илэрхийлэх чадвар сууж, бусад хүмүүс мэнд асуухад хариулах чадвартай болно.Үндсэн мэдээллээр асуултад хариулж чадах ба тодорхой хэрэгцээгээ илэрхийлж, зааварчилгаа өгч, бусдаас тусламж хүсэх чадвартай болох юм.',
      },
      {
        title: '读',
        intro:
          'Нийгмийн харилцаанд түгээмэл хэрэглэгддэг мэндчилгээ болон талархлын үгсийг мөн өдөр тутамд тохиолддог хамгийн энгийн тоо болон үсэгнүүдийг ерөнхийд нь ойлгох чадвартай болно.Өдөр тутмын амьдралд түгээмэл тохиолддог таних тэмдэг, хүснэгт, газрын зураг гэх мэт зүйлүүдээс үндсэн мэдээллийг олох чадвартай болно.',
      },
      {
        title: '写',
        intro:
          'Үндсэн бичгийн хэлээр илэрхийлэх чадвартай болно. Нийгмийн харилцаанд түгээмэл хэрэглэгддэг амархан хэллэгүүд, амархан үг болон өргөн хэрэглэгддэг дан өгүүлбэрээр хувийн мэдээллээ бөглөх чадвартай болдог.',
      },
      { title: '译', intro: 'Холбогдохгүй' },
    ],
    level2: [
      {
        title: '听',
        intro:
          'Өдөр тутамд түгээмэл үзэгддэг болон хувийн мэдээлэлтэй холбоотой энгийн зааварчилгааг сонсоод ойлгох чадвартай ба ярилцлагад холбогдох цаг хугацаа, байршил гэх мэт ерөнхий мэдээллийг олж авахаас гадна дохионы хэл, нүүрний хувирал болон бусад аргаар ерөнхий мэдээллийг ойлгох чадвартай болно.',
      },
      {
        title: '说',
        intro:
          'Хувийн эсвэл өдөр тутамд тохиолдох энгийн зааварчилгаа болон шаардлагыг хамгийн сайн мэдэх асуултаараа илэрхийлж, хувийн ерөнхий мэдээллийг илэрхийлэх чадвартай.Хялбар дан өгүүлбэрээр асуултад хариулж, нийгмийн харилцаанд орох боломжтой.',
      },
      {
        title: '读',
        intro:
          'Нийгмийн харилцаанд түгээмэл хэрэглэгддэг мэндчилгээ болон урилга гэх мэт товч бичгийн материал болон танилцуулга, өгүүлэмж гэх мэт хэл шинжлэлийн материалаас тодорхой зорилтот мэдээллийг авч, энгийн мэдэгдэл, зурвас гэх мэтийг ерөнхийд нь уншаад ойлгох чадвартай болно.',
      },
      {
        title: '写',
        intro:
          'Баярын мэндчилгээ, салах ёс гэх мэт сэтгэл хөдлөлөө энгийн үг өгүүлбэрээр илэрхийлж чадна. Хувийн амьдрал эсвэл хичээл гэх мэт нягт холбоотой ерөнхий мэдээллийг энгийн өгүүлбэрээр танилцуулах чадвартай.',
      },
      { title: '译', intro: 'Холбогдохгүй' },
    ],
    level3: [
      {
        title: '听',
        intro:
          'Өдөр тутмын амьдралтай холбоотой зааварчилгаа, харилцан яриа болон ярилцлагын үгнүүдийг сонсоод ойлгох чадвартай мөн ярилцлагын янз бүрийн нөхцөлд тодорхой мэдээллийг ойлгож танилцуулах, амархан үлгэр, реклам эсвэл мэдээний агуулгыг ойлгох чадвартай. Дуудлага, аялаг, ярианы хурдны өөрчлөлт зэргийг туслах хэрэгслүүдээр мэдээллийг ойлгож, өөрийн болгох чадвартай болно.',
      },
      {
        title: '说',
        intro:
          'Цөөн тооны харьцангуй төвөгтэй өгүүлбэрийн бүтцийг ашиглан ярилцах эсвэл мэтгэлцэх чадвартай болохоос гадна хувийн болон өдөр тутмын нийтлэг үйл ажиллагаа, үүсэж буй нөхцөл байдал эсвэл энгийн үйл явдлыг дүрслэх мөн энгийн зааварчилгааг өгөх чадвартай.',
      },
      {
        title: '读',
        intro:
          'Энгийн нийлмэл өгүүлбэрийг ойлгох; хүүрнэх,тайлбарлах гэх мэт хэл шинжлэлийн материалыг уншиж ойлгохоос гадна эхийн гол утга санаа болон нарийвчилсан мэдээллийг ойлгох чадвартай. Толь бичиг ашиглаж шинэ үгийн утгыг ойлгож чаддаг болох.',
      },
      {
        title: '写',
        intro:
          'Бичгийн ерөнхий ур чадварт суухаас гадна, энгийн бичгээр харилцах чадвартай. Хувийн болон гэр бүлтэй холбоотой мэдээлэл эсвэл сайн санаж байгаа хэрэг явдал болон төлөвлөгөө гэх мэт сэдвийг чөлөөтэй,ойлгомжтой, товчхон өгүүлэх чадвартай.',
      },
      { title: '译', intro: '不涉及。' },
    ],
    level4: [
      {
        title: '听',
        intro:
          '能听懂一般交际场合标准、清晰的对话，抓住主要内容，领悟说话人的重点或意图。偶尔会需要说话方重复。',
      },
      {
        title: '说',
        intro:
          '能在一般社交场合较自信地与他人交流，能参加小组讨论或做报告，就某件事情提出建议、给出理由、表达自己的观点。',
      },
      {
        title: '读',
        intro:
          '读懂叙述性、说明性等语言材料及简单的议论文，理解主要内容，把握关键信息，并做出适当推断。',
      },
      {
        title: '写',
        intro:
          '能够使用简单的句式进行语段表达，能够完成常见的应用文体写作，格式基本正确。用词准确度较高，句式有一定的变化，表达较清楚。',
      },
      {
        title: '译',
        intro:
          '具备初步的翻译能力。能够完成非正式场合的接待和简单陪同口译任务，能够翻译简单的叙述性和说明性文本，译文大体准确。',
      },
    ],
    level5: [
      {
        title: '听',
        intro: '能听懂话题熟悉但内容抽象或复杂的发言，抓住主要内容，掌握说话人的目的、态度等。',
      },
      {
        title: '说',
        intro:
          '能在多数社交和工作场合自信并有效地与他人交流。能就一般性话题在具体或抽象层面进行讲述或参与讨论。',
      },
      {
        title: '读',
        intro:
          '能理解复杂的复句，读懂有一定长度的材料或相当复杂的介绍性或说明性材料，理解、概括语言材料的中心意思或论点论据。能进行逻辑推断，较好理解所涉及的文化因素。',
      },
      {
        title: '写',
        intro:
          '能够使用较为复杂的句式进行语段表达，能够撰写一般性文章，就具体或一般性抽象话题进行描述、解释或说明，用词较为恰当，表达较为通顺。',
      },
      {
        title: '译',
        intro:
          '具备基本的翻译能力。能够完成非正式场合的简单交替传译任务，能够翻译一般的叙述性、说明性或议论性文本，能够对翻译中涉及的文化因素进行基本处理。',
      },
    ],
    level6: [
      {
        title: '听',
        intro:
          '能够规避一些方音、语病的影响，听懂各种交际活动中的对话或讲话，以及基本理解涉及的文化内容。',
      },
      {
        title: '说',
        intro: '能用中文自如地进行各种社会交际活动，中文口语水平接近母语者。',
      },
      {
        title: '读',
        intro:
          '能够厘清语言材料的结构层次，准确理解内容，摘取主要论点和信息，基本理解所涉及的文化内容。具有较强的跳读、查找信息、概括要点等阅读技能。',
      },
      {
        title: '写',
        intro:
          '能够使用较长和较为复杂的句式进行语段表达，能够完成多种应用文体写作，能够运用常见的修辞手法，内容完整，表达规范。',
      },
      {
        title: '译',
        intro:
          '具备一般的翻译能力。能够完成非正式场合的口译任务，能够翻译常见的叙述性、说明性、议论性文本，能够对翻译中涉及的文化因素进行恰当的处理。',
      },
    ],
    level7: [
      {
        title: '听',
        intro:
          '能够听懂语速正常或较快的各类语言材料。能够不受环境等因素的干扰，总结概括要点。能够理解所涉及的社会文化内涵。',
      },
      {
        title: '说',
        intro: '能够运用所学完成相关的话题表达和交际任务，发音准确，语调自然，表达得体。能够灵活运用修辞手段增强口头表达效果，体现一定的跨文化交际能力。',
      },
      {
        title: '读',
        intro:
          '能够准确且快速读懂各类文章，熟练掌握阅读技能，理解文章思想与社会内涵。',
      },
      {
        title: '写',
        intro:
          '能够手写相应篇幅的应用文、说明文、议论文和专业论文。观点明确，层次清晰，语句流畅，逻辑清楚。能够正确运用比较丰富的成语、习用语和多种修辞方法。',
      },
      {
        title: '译',
        intro:
          '具备基本的专业翻译能力。能够完成交替传译，表达流畅，符合中文表达习惯。能够翻译文章，译文通顺，格式准确。',
      }]
  },
  
}
